//ScanItem
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    ButtonContainer,
    TextBold,
    Title,
    SuccessMsg,
} from './scanItems.styled';
import TabControl from 'src/common/refactoredComponents/tabControl/tabControl';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import ScanQR from 'src/assets/images/ScanQR.svg';
import InputBox from 'src/common/refactoredComponents/input/Input';
import MDICheckBold from 'src/assets/images/MDICheckBold.svg';
import { sizes } from 'src/styles/Media.styled';
import { useTranslation } from 'react-i18next';
import { successMessageCamera } from 'src/common/barCodeScannerRedux/actions/actionCreators';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import {DARK_GRAY_FONT_COLOR} from 'src/styles/fonts/MCFontConstants';
import { logErrorToConsole } from 'src/utils/util';

const ScanItem = ({

    cursorOnInput,
    handleExternalBarcode,
    handleExtScanCam,
    isBundleScanItem,
    setDisableDoneButton,
    isConsignment = false,
    activeTab,
    setActiveTab,
    externalBarcode,
    setExternalBarcode,
}) => {
    const [, setExternalScanner] = useState(false);
    const dispatch = useDispatch();
    const isBarcodeControlled =
        externalBarcode !== undefined && !!setExternalBarcode;
    // Only pass value/onChange when controlled, so InputBox keeps its own onChange otherwise.
    const barcodeInputProps = isBarcodeControlled
        ? {
              value: externalBarcode,
              onChange: (e) => setExternalBarcode(e.target.value),
          }
        : {};

    const barcodeData = useSelector(
        (state) => state.BarCodeScannerReducer.barcodeDetails
    );
    const isLanguageChanged = useSelector(
        (state) => state.loginReducer.isLanguageChanged
    );
    
    const isCondensedView = useSelector((state) => state.loginReducer.isCondensedView);

    const [ShowMessage, setShowMessage] = useState(false);

    useEffectWithErrorLogging(() => {
        if (barcodeData?.statusCode === '10001') {
            setShowMessage(true);
            setTimeout(() => {
                try{
                setShowMessage(false);
                } catch (error) {
                    logErrorToConsole(error);
                }
            }, 3000); // Display the message for 2 seconds
        }
    }, [barcodeData]);

    const messageCamera = useSelector(
        (state) => state.BarCodeScannerReducer.succesMessageCamera
    );

    useEffectWithErrorLogging(() => {
        if (messageCamera) {
            setShowMessage(true);
            setTimeout(() => {
                try {
                setShowMessage(false);
                } catch (error) {
                    logErrorToConsole(error);
                }
            }, 3000);
        }
        dispatch(successMessageCamera(false));
    }, [messageCamera]);
 


    // useEffectWithErrorLogging(() => {
    //     setSuccesMesssage(false);
    // }, [isBundleScanItem]);
    const { t } = useTranslation();
    return (
        <>
            <TabControl
                tabOneTitle={t(
                    'receiveSets.ReceiveSetsLoc.AddSetsLists.camera'
                )}
                tabTwoTitle={t(
                    'receiveSets.ReceiveSetsLoc.AddSetsLists.externalScanner'
                )}
                isCondensedView={isCondensedView}
                currentActiveIndex={activeTab ?? 0}
                selectedTabState={setActiveTab}
                border={'1px solid #C8C8C8'}
                borderRadius={'4px'}
                tabFontSize={'13px'}
                tabFontColor={DARK_GRAY_FONT_COLOR}
                tabOneId="common-scanItems-tabCamera"
                tabTwoId="common-scanItems-external"
                tabViewMargin={'0 0 0 0'}
                 tabViewWidth={'50% !important'}
                // tabViewWidthLargeDevice={'57%'}
                tabOneChildren={
                    <ButtonContainer>
                        <Button
                            id={'common-scan-camera'}
                            show={true}
                            variant={ButtonStyles?.secondary}
                            width={isLanguageChanged ? '215px' : '187px'}
                            height={'40px'}
                            mobileWidth={'100%'}
                            margin={
                                isBundleScanItem
                                    ? '24px 7px auto 0px'
                                    : isConsignment
                                    ? '24px 10px auto 0px'
                                    : '24px 22px auto 0px'
                            }
                            mobileMargin={'24px 0 0 0'}
                            fontSize={'14px'}
                            padding={'5px 20px'}
                            borderRadius={'50px'}
                            clicked={() => {
                                try {
                                if (isBundleScanItem) {
                                    setDisableDoneButton(false);
                                }
                                setExternalScanner(false);
                                handleExtScanCam();
                                 } catch (error) {
                                     logErrorToConsole(error);
                                }
                            }}
                        >
                            <div>
                                <img
                                    src={ScanQR}
                                    style={{
                                        marginTop: '4px',
                                    }}
                                />
                            </div>
                            <TextBold isScan={true}>
                                {t(
                                    'receiveSets.ReceiveSetsLoc.ScanBardCodePopUp.popUpMsg'
                                )}
                            </TextBold>
                        </Button>
                        {isBundleScanItem &&
                        ShowMessage &&
                        window.innerWidth >= sizes.mobileDevice ? (
                            <div
                                style={{
                                    marginLeft: '20px',
                                    marginTop: '24px',
                                }}
                            >
                                <img
                                    src={MDICheckBold}
                                    style={{
                                        float: 'left',
                                        marginTop: '3px',
                                        marginRight: '5px',
                                    }}
                                />
                                <SuccessMsg
                                    mbMargin={'0 0 0 5px'}
                                    float={'left'}
                                >
                                    {t('common.itemsAddedToTheBundle')}
                                </SuccessMsg>
                            </div>
                        ) : null}
                    </ButtonContainer>
                }
                tabTwoChildren={
                    <div
                        style={{
                            margin: '20px 0 0 0px',
                        }}
                    >
                        <Title style={{ margin: '0 10px' }}>
                            {t(
                                'receiveSets.ReceiveSubmit.ReceivedSets.barcode'
                            )}
                        </Title>
                        <div
                            style={{
                                flexDirection: 'row',
                                display: 'flex',
                            }}
                        >
                            <InputBox
                                id={'common-scanItems-scanItems-externalBarcode'}
                                placeholder={t(
                                    'receiveSets.ReceiveSetsLoc.AddSetsLists.selectExternalScanner'
                                )}
                                width={isBundleScanItem ? '50%' : '80%'}
                                fromConsignmentScanning={true}
                                {...barcodeInputProps}
                                onKeyUp={(e) => {
                                    e.preventDefault();

                                    if (e.key === 'Enter') {
                                        setExternalScanner(true);
                                        if (isBundleScanItem) {
                                            setDisableDoneButton(false);
                                        }
                                        setTimeout(
                                            () => setExternalScanner(false),
                                            2000
                                        );
                                        handleExternalBarcode(e);
                                        isBarcodeControlled
                                            ? setExternalBarcode('')
                                            : (e.target.value = '');
                                    }
                                }}
                                autoFocus={cursorOnInput && 'on'}
                            />
                            {isBundleScanItem &&
                            ShowMessage &&
                            window.innerWidth >= sizes.mobileDevice ? (
                                <div
                                    style={{
                                        marginLeft: '20px',
                                        marginTop: '10px',
                                    }}
                                >
                                    <img
                                        src={MDICheckBold}
                                        style={{
                                            float: 'left',
                                            marginTop: '3px',
                                            marginRight: '5px',
                                        }}
                                    />
                                    <SuccessMsg
                                        mbMargin={'0 0 0 5px'}
                                        float={'left'}
                                    >
                                        {t('common.itemsAddedToTheBundle')}
                                    </SuccessMsg>
                                </div>
                            ) : null}
                        </div>
                    </div>
                }
            />
            {isBundleScanItem &&
            ShowMessage &&
            window.innerWidth <= sizes.mobileDevice ? (
                <div
                    style={{
                        flexDirection: 'row',
                        display: 'flex',
                        marginLeft: '20px',
                        marginTop: '10px',
                    }}
                >
                    <img src={MDICheckBold} />
                    <SuccessMsg mbMargin={'0 0 0 5px'}>
                        {t('common.itemsAddedToTheBundle')}
                    </SuccessMsg>
                </div>
            ) : null}
        </>
    );
};

export default ScanItem;
